import config from '../../../../config';
import { AddLicenseVersion, AddLicenseVersionApi } from '../../../domainModels/licenceVersions/AddLicenseVersion';
import { UpdateLicenseVersion } from '../../../domainModels/licenceVersions/UpdateLicenseVersion';
import { UpdateLicenseApiModel, UpdateLicenseModel } from '../../../domainModels/licences/UpdateLicense';

import { axiosInstance as axios } from '../../axios/axiosInstance';
import { addLicenseVersionModelToApi } from './mappings/addLicenseVersionModelToApi';
import { updateLicenseVersionModelToApi } from './mappings/updateLicenseVersionModelToApi';

export const licenseVersionsEndpoint = `${config.tachoAPI.url}/LicenseVersions`;

export const addLicenseVersion = (newLicense: AddLicenseVersion): Promise<AddLicenseVersion> => {
    const mappedLicenseToGenerate = addLicenseVersionModelToApi(newLicense);
    return axios
        .post<AddLicenseVersionApi>(licenseVersionsEndpoint, mappedLicenseToGenerate)
        .then(() => {
            return newLicense;
        })
        .catch(error => {
            if (error.response?.status === 409) {
                throw Error('licenceVersionsMustBeContinuous');
            }
            throw Error(addLicenseVersion.name + error);
        });
};

export const removeLicenseVersion = (licenseVersionId: string, licenseNumber: string): Promise<string> => {
    return axios
        .delete<string>(`${licenseVersionsEndpoint}`, {
            data: { licenseVersionId: licenseVersionId, licenseNumber: licenseNumber },
        })
        .then(() => {
            return licenseVersionId;
        })
        .catch((error: string) => {
            throw Error(removeLicenseVersion.name + error);
        });
};

export const updateLicenseVersion = (
    updatedLicenseVersion: UpdateLicenseVersion,
    licenseNumber: string,
): Promise<UpdateLicenseModel> => {
    const mappedLicense = updateLicenseVersionModelToApi(updatedLicenseVersion);
    return axios
        .patch<UpdateLicenseApiModel>(`${licenseVersionsEndpoint}/${licenseNumber}`, mappedLicense)
        .then(() => {
            return updatedLicenseVersion;
        })
        .catch(error => {
            if (error.response?.status === 409) {
                throw Error('licenceVersionsMustBeContinuous');
            }
            throw Error(updateLicenseVersion.name + error);
        });
};
